<template>
    <div id="main-wrapper">
        <NavbarDark/>
        <section class="bg-primary position-relative">
            <div class="position-absolute start-0 top-0 w-25 h-15 bg-light rounded-end-pill opacity-25 mt-4"></div>
            <div class="position-absolute start-0 bottom-0 w-15 h-20 bg-light rounded-top-pill opacity-25 ms-4"></div>
            <div class="position-absolute end-0 top-0 w-15 h-25 bg-light rounded-bottom-pill opacity-25 me-4"></div>
            <div class="position-absolute end-0 bottom-0 w-25 h-15 bg-light rounded-start-pill opacity-25 mb-4"></div>
            <div class="ht-30"></div>
            <div class="ht-30"></div>
        </section>

        <section class="gray-simple">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12 col-md-12">
                        <div class="item-shorting-box">
                            <div class="item-shorting clearfix">
                                <div class="left-column pull-left">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row justify-content-center g-4">
                    <div v-if="companies.length === 0">
                        <p>{{ $t('There is no company until now!') }}</p>
                    </div>
                    <div class="row justify-content-center g-4">
                        <div v-for="(item, index) in companies" :key="index" class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                            <div class="property-listing card rounded-3"
                                :class="border ? 'border' : 'border-0'">

                                <div class="listing-img-wrapper p-3">
                                <div class="rounded-3 overflow-hidden">
                                    <img
                                        :src="item.profile_image"
                                        class="img-fluid"
                                        alt="profile image"
                                        loading="lazy"
                                    />
                                </div>
                                </div>

                                <div class="listing-caption-wrapper px-3">
                                <h4 class="listing-name fw-semibold fs-5 mb-2 mt-3">
                                    <router-link :to="`/${locale}/company/${item.slug[locale]}`">
                                    {{ item.name }}
                                    </router-link>
                                </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="scroll-sentinel" class="text-center my-4">
                    <span v-if="loading">{{ $t('Downloading..') }}</span>
                </div>
            </div>		
        </section>

        <FooterTop :bg="'theme-bg'"/>
        <FooterDark/>
        <ScrollToTop/>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from 'vue';
import axios from 'axios';
import FooterDark from '@/components/footer/footer-dark.vue';
import FooterTop from '@/components/footer/footer-top.vue';
import NavbarDark from '@/components/navbar/navbar-dark.vue';
import ScrollToTop from '@/components/scroll-to-top.vue';
import { useI18n } from "vue-i18n";

const companies = ref([]);
const currentPage = ref(1);
const totalPages = ref(1);
const totalResults = ref(0);
const perPage = ref(0);
const from = ref(0);
const to = ref(0);
const loading = ref(false);
const observer = ref(null);

const { locale } = useI18n();

const fetchCompanies = async (reset = false) => {
    if (loading.value) return;

    if (reset) {
        currentPage.value = 1;
        totalPages.value = 1;
        companies.value = [];
    }

    if (currentPage.value > totalPages.value) return;

    loading.value = true;

    try {
        const page = currentPage.value;

        const response = await axios.get(`/companies?page=${page}`, {
            headers: {
                locale: locale.value
            }
        });

        if (page === 1) {
            companies.value = response.data.data;
        } else {
            companies.value.push(...response.data.data);
        }

        totalResults.value = response.data.total;
        perPage.value = response.data.per_page;
        totalPages.value = response.data.last_page;

        from.value = companies.value.length
            ? 1
            : 0;

        to.value = companies.value.length;

        currentPage.value++;

    } catch (error) {
        console.error('Error fetching companies:', error);
    } finally {
        loading.value = false;
    }
};

const setupObserver = () => {
    observer.value = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && !loading.value) {
            fetchCompanies();
        }
    });

    const sentinel = document.getElementById('scroll-sentinel');

    if (sentinel) {
        observer.value.observe(sentinel);
    }
};

onMounted(() => {
    setupObserver();
});

onUnmounted(() => {
    if (observer.value) {
        observer.value.disconnect();
    }
});

watch(
    locale,
    async () => {
        await fetchCompanies(true);
    },
    { immediate: true }
);
</script>


